
import LevelWiseReport from '../../Component/TeamOverview/LevelWiseReport'
const LevelwiseTeamList = () => {
  return (
    <div className='page-body'>
          <LevelWiseReport/>
    </div>

  )
}

export default LevelwiseTeamList